






import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class IconSvg extends Vue {
  @Prop()
  private iconClass: any;
  @Prop()
  private className: any;
  private get iconName() {
    return `#icon-${this.iconClass}`;
  }
  private get svgClass() {
    if (this.className) {
      return "svg-icon " + this.className;
    } else {
      return "svg-icon";
    }
  }
}
